var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.pageLayout,{tag:"component",attrs:{"material":_vm.materials[0],"ads-layout":_vm.adsLayout},on:{"ads:click":function($event){return _vm.onAdsClick(_vm.materials[0].contents.companyLogo.link)}}})}
var staticRenderFns = []

export { render, staticRenderFns }